<template>
  <div class="container">
    <!-- 上面部分：四块卡片 -->
    <div class="top-section">
          <el-card class="card" :body-style="{padding: '0px',height:'90%'}">
            <div class="today">
                <p class="title">日充电次数</p>
                <p class="title">{{chargeInfos.dayChargeNum}}</p>
            </div>
            <div class="today" :body-style="{padding: '0px',height:'90%'}">
                <p class="title">日充电度数</p>
                <p class="title">{{chargeInfos.dayChargeCount}}</p>
            </div>
          </el-card>
          <el-card class="card" :body-style="{padding: '0px',height:'90%'}">
            <div class="today">
                <p class="title">月充电次数</p>
                <p class="title">{{chargeInfos.monthChargeNum}}</p>
            </div>
            <div class="today" :body-style="{padding: '0px',height:'90%'}">
                <p class="title">月充电度数</p>
                <p class="title">{{chargeInfos.monthChargeCount}}</p>
            </div>
          </el-card>
          <el-card class="card" :body-style="{padding: '0px 50px',height:'90%'}">
            <div class="total">
                <p class="title">总沉淀积分</p>
                <p class="title">{{chargeInfos.depositeCount}}</p>
            </div>
          </el-card>
          <el-card class="card" :body-style="{padding: '0px 50px',height:'90%'}">
            <div class="total">
                <p class="title">总会员数</p>
                <p class="title">{{chargeInfos.memCount}}</p>
            </div>
          </el-card>
    </div>

    <!-- 中间部分：两块卡片 -->
    <div class="middle-section">
          <el-card class="card" :body-style="{height: '100%'}">
            <!-- 图形图标的容器 -->
            <div class="charts" ref='echartsDom'></div>
          </el-card>

          <el-card class="card" :body-style="{padding: '12px 10px'}">
            <p class="tableTitle">会员充电次数环比下降明显预警</p>
            <!-- 表格组件 -->
            <el-table :data="tableData" stripe style="width: 100%;"  border
              :header-cell-style="{ background: '#eef1f6', color: '#606266','text-align':'center' }"
              :cell-style="{'text-align':'center'}"
            >
              <el-table-column label="会员姓名" prop='memRealName'></el-table-column>
              <el-table-column label="手机号" prop='memTel'></el-table-column>
              <el-table-column label="上月充电次数" prop='preMonthCount'></el-table-column>
              <el-table-column label="本月充电次数" prop='currMonthCount'></el-table-column>
              <el-table-column label="环比下降" prop='hq'></el-table-column>
            </el-table>
          
          </el-card>
    </div>

    <!-- 下面部分：一块卡片 -->
    <div class="bottom-section">
      <el-card class="card" :body-style="{height: '100%'}">
        <!-- 图形图标的容器 -->
        <div class="charts" ref='echartsMonthDom'></div>
      </el-card>
    </div>

  </div>
</template>

<script>


import { getDayCharge, getMonthCharge, getChargeInfo,chargeRiskInfo } from '@/api/report.js'


export default {
  data() {
    return {
      // 表格数据
      tableData: [],
      chargeInfos:{}
    };
  },
  mounted() {
      this.yearChart()
      this.monthChart()
      this.chargeInfo()
      this.chargeRiskInfo()
    },

  methods:{
    async yearChart(){
      const data1 = await getMonthCharge()
      // 基于准备好的dom，初始化echarts实例  
      var myChart = this.$echarts.init(this.$refs.echartsDom);
      
      // 指定图表的配置项和数据
      var option = {
        title: {
          text: '近12个月充电次数和人数',
          left: 'center',
          top: 0
        },
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: ['次数', '人数'],
          left:'right'
        },
        grid: {
          left: '2%',
          right: '4%',
          bottom: '2%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: data1.data.map(item=>item.statisticDt)
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            name: '次数',
            type: 'line',
            data: data1.data.map(item=>item.chargeCount)
          },
          {
            name: '人数',
            type: 'line',
            data: data1.data.map(item=>item.userCount)
          },
        ]
      };
      
      // 使用刚指定的配置项和数据显示图表。  
      myChart.setOption(option)
    },

    async monthChart(){
      const data2 = await getDayCharge()
      // 基于准备好的dom，初始化echarts实例  
      var myChart = this.$echarts.init(this.$refs.echartsMonthDom);
      
      // 指定图表的配置项和数据
      var option = {
        title: {
          text: '近30天充电次数和人数',
          left: 'center',
          top: 0
        },
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: ['次数', '人数'],
          left:'85%'
        },
        grid: {
          left: '2%',
          right: '2%',
          bottom: '2%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: data2.data.map(item=>item.statisticDt)
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            name: '次数',
            type: 'line',
            data: data2.data.map(item=>Number(item.chargeCount))
          },
          {
            name: '人数',
            type: 'line',
            data: data2.data.map(item=>Number(item.userCount))
          },
        ]
      };
      
      // 使用刚指定的配置项和数据显示图表。  
      myChart.setOption(option)
    },

    async chargeInfo(){
      const data3 = await getChargeInfo()
      this.chargeInfos = data3.data
    },

    async chargeRiskInfo(){
      const data3 = await chargeRiskInfo()
      this.tableData = data3.data
    }
  }
};
</script>

<style scoped>
.container {
  display: flex;
  flex-direction: column;
  height: 130%; 
  padding: 10px 0px 0px 12px;
}

.top-section {
  height: 30% ;
  display: flex;
}

.middle-section {
  width: 100%;
  height: 50% ;
  display: flex;
  margin: 10px 0px;
}

.bottom-section {
  width: 100%;
  height: 50% ;
  display: flex;
}

.card {
  text-align: center;
  font-size: 18px;
  color: #333;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  width: 100% !important;
  height: 100% !important;
  margin-right: 10px;
}

.today{
  display: flex;
  justify-content: space-evenly;

  .title{
    width: 30%;
  }
}

.total{
  display: flex;
  flex-direction: column;
  align-items: center;

  .title{
    width: 70%;
  }
}

.title{
    color: #fff;
    background-color: #409eff;
    padding:10px;
    border-radius: 8px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.3);

    &:hover {
    background-color: #178afe;
    cursor: pointer; 
    }
  }
  

.tableTitle{
  display: block;
  color: #484848;
  font-weight: bold;
  margin: 0px;
  margin-bottom: 8px;
}
.charts {
  height: 100%;
  width: 100%;
}
</style>